
import type { SVGProps } from 'react';
const SvgMeinSchiffHerz = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#mein-schiff-herz_svg__a)">
      <path
        fill="#263E6A"
        fillRule="evenodd"
        d="M18.6 12a6.6 6.6 0 1 1-13.2 0 6.6 6.6 0 0 1 13.2 0m-5.632.435L12 10.912l.033-.201.233-.566-.173-.159-.207-.31h-1.11l-.573-.901h-.568l-.366-.599v-.061H7.343a6.053 6.053 0 0 0 .51 8.313h6.907s.61-.945 1.363-1.869c.752-.924 1.837-2.123 1.837-2.123zm-4.002 2.51a.3.3 0 0 1-.153-.034.5.5 0 0 1-.135-.12q-.46-.509-.81-.917a8 8 0 0 1-.58-.751 3.2 3.2 0 0 1-.347-.654 1.8 1.8 0 0 1-.116-.623q0-.19.052-.377a1 1 0 0 1 .172-.34.9.9 0 0 1 .313-.25q.193-.094.47-.094.404 0 .699.217.294.22.435.611a1.26 1.26 0 0 1 .44-.61q.297-.219.696-.218.277 0 .466.095.19.095.31.248.12.154.175.34.055.189.055.378 0 .313-.117.623a3.2 3.2 0 0 1-.346.654q-.23.344-.58.751t-.81.918a.5.5 0 0 1-.135.12.3.3 0 0 1-.154.033"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="mein-schiff-herz_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgMeinSchiffHerz;
